import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./lib/i18n";
import App from "@/App";
import { registerPWA } from "./lib/pwa";

registerPWA();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
